<template lang="pug">
  .eui-partyLabel(:data-party="code", :class="className")
    span.eui-partyLabel_icon(:style="{ '--party-color': color }")
      span.eui-partyLabel_icon_circle.eui-partyLabel_icon_light(:style="{ '--party-color-light': colorLight }")
      span.eui-partyLabel_icon_circle.eui-partyLabel_icon_dark
    span.eui-partyLabel_text {{ label }}
</template>

<script>

import { rgb } from 'd3-color';

export default {
  name: 'partyLabel',
  props: {
    color: String,
    code: String,
    name: String,
    useCode: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: 'horizontal'
    }
  },
  computed: {
    label() {
      return this.useCode ? this.code : this.name;
    },
    colorLight() {
      return rgb(this.color).copy({ opacity: 0.1 });
    },
    className() {
      return `eui-partyLabel_${ this.layout }`;
    }
  }
};

</script>

<style lang="scss">
  @import "src/core/scss/global-sass";

  .eui-partyLabel {
    display: inline-flex;
    line-height: 1;

    &_icon {
      display: flex;

      &_circle {
        width: 16px;
        height: 16px;
        border-radius: 100%;
        background-color: var(--party-color);
        border: 1px solid var(--party-color);
      }

      &_circle + &_circle {
        margin-left: -4px;
      }

      &_light {
        background-color: var(--party-color-light);
      }
    }

    &_horizontal {
      flex-direction: row;
      align-items: center;
    }

    &_horizontal &_icon {
      margin-right: $m-spacing;
    }

    &_vertical {
      flex-direction: column;
      align-items: center;
    }

    &_vertical &_icon {
      margin-bottom: $m-spacing;
    }
  }
</style>
